import { CHART_COLOURS_WAITS } from "../../../component/Constants";
import Helper from "../../../helpers/Helper";
import Wait from "../../../types/instance/Wait";
import { useEffect, useMemo, useState } from "react";
import React from "react";
import { ActivityHashData, InstanceOptions } from "./types";

function StatementWaits(props: {
    statement: ActivityHashData,
    waits: Wait[],
    instanceTime: number,
    instance: InstanceOptions
}) {
    const [tooltip, setTooltip] = useState<string>();
    let { statement} = props;
    const [statementWeight, setStatementWeight] = useState(0);

    useEffect(() => {
        if (props.instanceTime > 0 && props.statement !== undefined) {
            const newStatementWeight = Math.floor((100 / props.instanceTime) * statement.waittime);
            setStatementWeight(newStatementWeight);  // Store the calculated weight in state
        }
    }, [props.instanceTime, statement.waittime, props.statement]);

    useEffect(() => {
        
    }, [statementWeight]);

    useMemo(() => {

        if (statement === undefined || props.instanceTime === 0) {
            return;
        }

        let statementWaits: Wait[] = props.waits;

        let generatedTooltip: string = '';

        // Since waits length can be different get the shortest one length to avoid undefined data
        for (let index = 0; index < statementWaits.length - 1; index++) {

            const matchedWait = statementWaits.filter(wait => wait.waitevent === props.waits[index].waitevent);

            if (matchedWait.length > 0) {

                if (index < CHART_COLOURS_WAITS.length && statementWaits[index]) {

                    // Set the top colours for the chart.
                    statementWaits[index].color = CHART_COLOURS_WAITS[index];
                }

                // Work out the wait percentage.
                const weight = Math.floor((100 / statement.waittime) * statementWaits[index].waittime);

                // Set the statement weight and build the tooltip.
                statementWaits[index].weight = weight;

                if (weight >= 3) {
                    generatedTooltip = `${generatedTooltip}<li>${statementWaits[index].waitevent}: ${Helper.getTimeInEnglish(statementWaits[index].waittime)} (${statementWaits[index].weight}%)</li>`;
                }
            }
        }
        setTooltip('<p>This statement has the following top waits:</p><ol>{waits}</ol>'.replace('{waits}', generatedTooltip));


    }, [props.statement, props.waits, props.instanceTime, statement.waittime]);

    if (props.statement === undefined || statementWeight < 5) {
        return (
            <React.Fragment>-</React.Fragment>
        )
    }

    const waitsToDisplay = props.waits.filter(wait => wait.weight && wait.weight > 3)

    return (
        <React.Fragment>
            <div className='d-flex justify-content-end' style={{ width: `${statementWeight}%` }} data-tooltip-id="global-tooltip" data-tooltip-html={tooltip}>

                {waitsToDisplay.length ? waitsToDisplay.map((wait: Wait, index) => (
                    <div key={index} style={{ width: `${wait.weight}%`, backgroundColor: wait.color }}>&nbsp;</div>
                )) : '-'}
            </div>
        </React.Fragment>
    );
}

export default StatementWaits;
